import { render, staticRenderFns } from "./BannerSupport.vue?vue&type=template&id=17dbf555&scoped=true&"
import script from "./BannerSupport.vue?vue&type=script&lang=js&"
export * from "./BannerSupport.vue?vue&type=script&lang=js&"
import style0 from "./BannerSupport.vue?vue&type=style&index=0&id=17dbf555&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dbf555",
  null
  
)

export default component.exports